import { render, staticRenderFns } from "./TwAside.vue?vue&type=template&id=8bae39d4&"
import script from "./TwAside.vue?vue&type=script&lang=js&"
export * from "./TwAside.vue?vue&type=script&lang=js&"
import style0 from "./TwAside.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports